/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * データ登録エラー詳細
 * @export
 * @interface ResponseUpdateError
 */
export interface ResponseUpdateError {
    /**
     * 
     * @type {number}
     * @memberof ResponseUpdateError
     */
    rowno: number | null;
    /**
     * 
     * @type {string}
     * @memberof ResponseUpdateError
     */
    errorMessage: string | null;
    /**
     * 
     * @type {object}
     * @memberof ResponseUpdateError
     */
    rowdata: object | null;
}

/**
 * Check if a given object implements the ResponseUpdateError interface.
 */
export function instanceOfResponseUpdateError(value: object): value is ResponseUpdateError {
    if (!('rowno' in value) || value['rowno'] === undefined) return false;
    if (!('errorMessage' in value) || value['errorMessage'] === undefined) return false;
    if (!('rowdata' in value) || value['rowdata'] === undefined) return false;
    return true;
}

export function ResponseUpdateErrorFromJSON(json: any): ResponseUpdateError {
    return ResponseUpdateErrorFromJSONTyped(json, false);
}

export function ResponseUpdateErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseUpdateError {
    if (json == null) {
        return json;
    }
    return {
        
        'rowno': json['rowno'],
        'errorMessage': json['error_message'],
        'rowdata': json['rowdata'],
    };
}

export function ResponseUpdateErrorToJSON(json: any): ResponseUpdateError {
    return ResponseUpdateErrorToJSONTyped(json, false);
}

export function ResponseUpdateErrorToJSONTyped(value?: ResponseUpdateError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rowno': value['rowno'],
        'error_message': value['errorMessage'],
        'rowdata': value['rowdata'],
    };
}

